// Paylaşılan profil linkinden kullanıcı adı (1.3.3, 1.3.5 · D-649).
//
// Üç biçim aynı profile çıkar:
//   https://nosubject.co/batu      — evrensel bağlantı (uygulama yüklüyse iOS ve
//                                    Android bu linki doğrudan uygulamaya verir)
//   nosubject://u/batu             — web sayfasındaki "Uygulamada aç" düğmesi
//   https://nosubject.co/?u=batu   — "Web'de devam et": web uygulaması yolu
//                                    okumuyor, adı sorgudan alıyor
//
// `URL` kullanılmıyor: React Native'in URL sınıfında `searchParams` eksik ve
// burada çözülen bir hata uygulamayı açılışta düşürürdü.

// Sunucudaki kuralın aynısı (api/src/routes/users.ts — validateUsername).
const USERNAME = /^[A-Za-z][A-Za-z0-9_]{2,19}$/;

// API'deki RESERVED_USERNAMES ile aynı (api/src/routes/users.ts); bir API testi
// iki listenin ayrışmadığını denetliyor. Bu adlar kimsenin profili değil —
// ör. /mimari sitenin kendi sayfası — uygulama onları profil gibi açmamalı.
export const RESERVED_USERNAMES: ReadonlySet<string> = new Set([
  'admin', 'root', 'support', 'help', 'api', 'nosubject', 'about', 'terms',
  'privacy', 'login', 'signup', 'settings', 'me', 'user', 'users', 'profile',
  'u', 'app', 'www', 'mail', 'moderation', 'contact', 'legal', 'blog',
  'mimari', 'architecture',
]);

const WEB_HOSTS = new Set(['nosubject.co', 'www.nosubject.co', 'nosubject.web.app', 'nosubject.firebaseapp.com']);

function accept(candidate: string | undefined | null): string | null {
  if (!candidate || !USERNAME.test(candidate)) return null;
  return RESERVED_USERNAMES.has(candidate.toLowerCase()) ? null : candidate;
}

function queryParam(query: string, name: string): string | null {
  for (const part of query.replace(/^\?/, '').split('&')) {
    const [key, value = ''] = part.split('=');
    if (key === name) {
      try { return decodeURIComponent(value); } catch { return null; }
    }
  }
  return null;
}

/** Linkteki kullanıcı adı; profil linki değilse null. */
export function profileUsernameFromUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const scheme = /^nosubject:\/\/u\/([^/?#]+)\/?(?:[?#].*)?$/i.exec(raw.trim());
  if (scheme) return accept(scheme[1]);

  const web = /^https:\/\/([^/?#]+)(\/[^?#]*)?(\?[^#]*)?(?:#.*)?$/i.exec(raw.trim());
  if (!web || !WEB_HOSTS.has(web[1].toLowerCase())) return null;
  const path = web[2] ?? '/';
  if (path === '/' || path === '') return accept(queryParam(web[3] ?? '', 'u'));
  const segment = /^\/([^/]+)\/?$/.exec(path);
  return segment ? accept(segment[1]) : null;
}
